module.exports = __webpack_public_path__ + "static/media/TeamSnap_Icon.abf3ceb0.png";